import { render, staticRenderFns } from "./wxscustomer-add-or-update.vue?vue&type=template&id=065ce876&"
import script from "./wxscustomer-add-or-update.vue?vue&type=script&lang=js&"
export * from "./wxscustomer-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports